<template>
  <v-card :loading="loading" :disabled="loading" :flat="flat">
    <CardTitle v-if="!hide_header" :title="title ? 'Notes: '+ title : 'Notes'">
      <template v-slot:prepend_actions>
        <Note :customer_id="customer_id"></Note>
      </template>
      <template v-slot:actions>
        <slot name="title_actions"></slot>
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn v-on="on" @click="loadData" icon><v-icon>mdi-refresh</v-icon></v-btn>
          </template>
          <span>Reload Data</span>
        </v-tooltip>
      </template>
    </CardTitle>
    <v-card-text :class="dense ? 'pa-0' : ''">
      <v-data-table
          :dense="dense"
          :headers="table_headers"
          :items="items.filter(filter)"
          item-key="id"
          :disable-pagination="no_pagination"
          :hide-default-footer="no_pagination"
          :hide-default-header="hide_table_header"
          no-data-text="No Notes"
          no-results-text="No Notes"
      >
          <template v-slot:no-data>
            <div class="text-center">No Notes</div>
          </template>
        <template v-slot:no-results>
          <div class="text-center">No Notes</div>
        </template>
          <template v-slot:item.created_by="{item}">
            <Note editing :customer_id="customer_id" :data="item"></Note>
          </template>
      </v-data-table>
    </v-card-text>
    <slot name="actions"></slot>
  </v-card>
</template>

<script>
import Note from "@/views/DirectoryV2/components/forms/Note";
export default {
name: "Notes",
  components:{
    Note: () => import("@/views/DirectoryV2/components/forms/Note")
  },
  data: () => ({
    loading: false,
  }),
  props:{
    customer_id: {
      required: true,
    },
    title:{
      required: false,
    },
    billing_only: {
      default: false,
      type: Boolean
    },
    table_headers: {
      default: () => {
        return [
          {text: "Type", value:"note_type.desc"},
          {text: "Note", value:"note"},
          {text: "Created", value:"created_at"},
          {text: "Edit", value:"created_by"}
        ]
      }
    },
    hide_header:{
      default: false,
      type: Boolean
    },
    hide_table_header:{
      type: Boolean,
      default: false,
    },
    dense: {
      default: false,
      type: Boolean
    },
    filter:{
      default: () => {
        return (note) => true;
      }
    },
    flat: {
      default: false,
      type: Boolean
    },
    no_pagination: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    items(){
      if(this.billing_only){
        return this.$store.$db().model('notes').query().where(note => note.customer_id === this.customer_id && note.note_type_id === 4).with('note_type').all();
      }
      return this.$store.$db().model('notes').query().where('customer_id', this.customer_id).with('note_type').all();
    }
  },
  watch:{
    customer_id(){
      if(!this.loading){
        this.loadData();
      }
    }
  },
  mounted(){
    if(!this.loading){
      this.loadData();
    }
  },
  methods:{
    async loadData(){
      this.extraData();
      this.loading = true;
      try{
        await this.$store.$db().model('notes').api().fetch({
          where: {
            key: "customer_id",
            value: this.customer_id
          },
          with: 'noteType'
        });
      }catch(err){
        this.$store.dispatch("showError", "Failed to load data.")
      } finally {
        this.loading = false;
      }
    },
    extraData(){
      this.$store.$db().model('noteTypes').api().fetch();
    }
  }
}
</script>

<style scoped>

</style>
